export default function CoalIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5899C14.0873 17.5899 17.4007 14.2724 17.4007 10.1799C17.4007 6.08748 14.0873 2.7699 10 2.7699C5.91273 2.7699 2.59933 6.08748 2.59933 10.1799C2.59933 14.2724 5.91273 17.5899 10 17.5899Z"
                fill="black"
            />
            <path
                d="M10 6.10794L6.02127 13.0522H13.9788L10 6.10794Z"
                fill="white"
            />
        </svg>
    );
}
